import { Flex, IconPlusCircle, PageContent, Spacer } from '@zillow/constellation';
import { Heading, TextButton } from '@zillow/constellation-10';

import { AppSelectors } from '../../../selectors';
import { useSelector } from '../../../selectors/useSelector';
import accessUtils from '../../../utils/accessUtils';
import AddPropertyModalCSEvents from '../../../model/ClickstreamEvent/AddPropertyModalCSEvents';

type Props = {
  handleAddPropertyClick: () => void;
  handleAddFeedListingsClick: () => void;
};

const PageHeading = ({ handleAddPropertyClick, handleAddFeedListingsClick }: Props) => {
  const user = useSelector((state) => state.user);
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  const showAddPropertyButton = user.features.canAddListing;
  const canAccessAddFeedListingsModal = accessUtils.canAccessAddFeedListingsModal({ user });
  const showButtonsNextRow = isScreenMobile && showAddPropertyButton && canAccessAddFeedListingsModal;

  const pageTitle = 'Properties';

  const renderAddButtons = () => (
    <Flex display="flex">
      {showAddPropertyButton && (
        <TextButton
          textStyle="body-bold"
          tone="brand"
          onClick={handleAddPropertyClick}
          data-testid="AddPropertyButton"
          data-eventid={AddPropertyModalCSEvents.Open.data_event_id}
          data-eventdescription="View add property modal"
        >
          <Spacer marginRight="xs" as="span">
            <IconPlusCircle size="sm" />
          </Spacer>
          Add a property
        </TextButton>
      )}
      {canAccessAddFeedListingsModal && (
        <Spacer paddingLeft="md">
          <TextButton
            textStyle="body-bold"
            tone="brand"
            onClick={handleAddFeedListingsClick}
            data-eventid={AddPropertyModalCSEvents.AddFeedClick.data_event_id}
            data-eventdescription="View add feed modal"
          >
            <Spacer marginRight="xs" as="span">
              <IconPlusCircle size="sm" />
            </Spacer>
            Add feed
          </TextButton>
        </Spacer>
      )}
    </Flex>
  );

  return (
    <PageContent marginBottom={2}>
      {!showButtonsNextRow && (
        <Flex display="flex" alignItems="center">
          <Flex flex="1">
            <Heading level={1} fontFamily="heading-alt" textStyle="heading-md">
              {pageTitle}
            </Heading>
          </Flex>
          <Spacer paddingLeft="sm">{renderAddButtons()}</Spacer>
        </Flex>
      )}
      {showButtonsNextRow && (
        <Flex>
          <Heading level={1} fontFamily="heading-alt" textStyle="heading-md">
            {pageTitle}
          </Heading>
          <Spacer paddingTop="sm">{renderAddButtons()}</Spacer>
        </Flex>
      )}
    </PageContent>
  );
};

export default PageHeading;
